<template>
  <div>
    <div class="order-con order-con0" v-if="orderList.length==0">
      客户未进件，请为他选择合适的产品吧。
    </div>
    <div v-else>
      <div
        class="order-con"
        v-for="(item,index) in orderList"
        :key="index"
        @click="checkOrder(item)"
      >
        <div class="con-sty">
          <div>
            <div class="con-div">
              <div>订单编号：{{item.orderId}}</div>
              <div>产品名称：{{item.productName}}</div>
            </div>
            <div class="con-div">
              <div>放款类型：{{item.loanTypeDesc}}</div>
              <div>客户名称：{{item.cusName}}</div>
            </div>
            <div>进件时间：{{item.createTime}}</div>
            <div>放款时间：{{item.settlementEntryTime}}</div>
          </div>
          <img class="arrow" src="@/assets/publicImg/arrow.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    orderList:{
      type:Array
    }
  },
  data() {
    return {
    }
  },
  methods:{
    checkOrder(item){
      this.$router.push({ path: '/loanOrderDetail', query: { id: item.orderId } })
    }
  }
}
</script>

<style lang="less" scoped>
.order-con0{
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.order-con {
  width: 355px;
  height: 80px;
  background: url("../../assets/publicImg/con-bg.png") no-repeat 50%;
  background-size: 100% 100%;
  // padding: 13px 0;
  margin: 10px auto auto;
  font-size: 11px;
  font-weight: 400;
  color: #666666;
  position: relative;
  .con-sty {
    display: flex;
    width: 335px;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: space-between;
  }
  .con-div {
    display: flex;
    div {
      &:last-child {
        margin-left: 15px;
      }
    }
  }
  .arrow {
    width: 5px;
    height: 7px;
  }
}
</style>